import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {SearchInput} from '../search-bar/SearchInput';
import {setSearchResult} from "../../redux/action/search_actions";
import {connect} from "react-redux";
import {DownloadItem} from "../item/DownloadItem";
import {Spinner} from "../spinner/Spinner";

class SearchManualSectionContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      result: []
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.result)
      this.setState({ result: nextProps.result });

    if(nextProps.open !== this.props.open)
      this.setState({
        result: [],
        selectedIndex: -1
      });
  }

  render(){
    const search_results = this.state.result && this.state.result
      .map( ( result, index ) => {
        return (
          <DownloadItem key={index} id={result.ID} item={result}/>
        );
      });

    return (
      <div className="manual-search-container" style={this.image}>
        <div className="manual-search-content">
          <Container>
            <Row>
              <Col xs="12" md="12" lg="6" className="mb-5">
                <h3>Downloads</h3>
                <div className={"downloads-container"}>
                  <p>Find user manuals and datasheets for all current Obelux products</p>
                  <SearchInput className="search-input"
                               resultPath="download"/>
                </div>
                {
                  ( this.props.loading || ( this.state && Array.isArray(this.state.result) && this.state.result.length > 0 )) &&
                  <div className="download-item-container">
                    {
                      this.props.loading
                        ? <Spinner/>
                        : search_results
                    }
                  </div>
                }
              </Col>
              <Col xs="12" md="12" lg="6">
                <h3>Talk to us</h3>
                <div className={"manual-search-talk-to"}>
                  <p className="strong">Obelux Support Hotline</p>
                  <p><a href={ "tel:" + this.props.tel }>{ this.props.tel }</a></p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export const SearchManualSection = connect(
  state => ({
    loading: state.search.loading,
    result: state.search.result.download,
    search_str: state.search.value
  }),
  dispatch => ({
    setSearchResult: result => dispatch(setSearchResult(result))
  })
)(SearchManualSectionContainer);



// WEBPACK FOOTER //
// ./src/components/search-manual-section/SearchManualSection.js